import { TokenInfo } from '@labb/constellation-core-types';

import { API_ERROR_CODES } from '../../onboarding-api';
import { SingpassResult } from '../../singpass/singpassTypes.ts';

type PegaIdvCallbackResponse = {
  assignmentKey: string;
};

type ApiPostPegaIdvCallbackResult = {
  data?: PegaIdvCallbackResponse;
  errorCode?: API_ERROR_CODES;
};

export async function apiPostPegaIdvCallback(
  baseUrl: string,
  pegaToken: TokenInfo,
  singpassResult: SingpassResult
): Promise<ApiPostPegaIdvCallbackResult> {
  const url = `${baseUrl}/api/nexus/v1/application/${singpassResult.caseId}/idv-callback`;

  return fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      status: singpassResult.status,
      userData: singpassResult.userData,
      error: singpassResult.error,
      errorDescription: singpassResult.errorDescription,
    }),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${pegaToken.access_token}`,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        return {
          errorCode: API_ERROR_CODES.GENERIC,
        };
      }

      const responseJson = await response.json();

      return { data: responseJson };
    })
    .catch(() => {
      return {
        errorCode: API_ERROR_CODES.GENERIC,
      };
    });
}
